import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { Grid2, IconButton, InputAdornment, TextField } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import React, { useMemo, useState } from "react";
import { ModalTreeFilterControl } from "./dialogFilter";

type TreePickerControlProps = {
	onSelect: (
		value: number,
		description: string,
		findNode: any,
		showPath?: boolean,
		listAssetDrawings?: number[],
		multipleSelectNodes?: boolean,
		onHide?: (showAssetTree?: boolean) => void,
		showAssetTree?: boolean,
	) => void;
	isLoading?: boolean;
	setListAssetDrawings?: Function;
	onSuccess?: (success: boolean) => void;
	showClearButton?: boolean;
	allowSearch?: boolean;
	[key: string]: any;
};

export const TreePickerControl = (props: TreePickerControlProps) => {
	const {
		onSelect,
		value,
		styleLabel,
		dataSource,
		inputTitle = "Asset",
		showPath = false,
		multipleSelectNodes = false,
		showClearButton = false,
		showAssetTree,
		onHide,
		listAssetDrawings = [],
		onSuccess,
		isLoading,
		allowSearch = false,
		...other
	}: TreePickerControlProps = props;
	const [open, setOpen] = useState(showAssetTree || false);

	const handleClickListItem = (
		e: React.MouseEvent<
			HTMLDivElement | HTMLTextAreaElement | HTMLInputElement
		>,
	) => {
		e.stopPropagation();
		setOpen(true);
	};

	const handleClose = (newValue: any, newDescription: any, findNode: any) => {
		if (!showAssetTree) {
			setOpen(false);
		}
		if (newValue !== undefined && newValue !== null) {
			if (onSelect !== undefined) {
				onSelect(newValue, newDescription, findNode);
			}
		}
	};

	const formatDescription = (description: string): string => {
		if (
			props.showPath &&
			description?.includes("/") &&
			description.split("/").length > 3
		) {
			const parts = description.split("/");
			let formattedDescription = "";

			for (let i = 0; i < parts.length; i++) {
				if (i < parts.length - 2) {
					formattedDescription += ".../";
				} else if (i === parts.length - 2) {
					if (parts[i].length > 6) {
						formattedDescription += parts[i].substring(0, 6) + ".../";
					} else {
						formattedDescription += parts[i] + "/";
					}
				} else {
					formattedDescription += parts[i];
					if (i < parts.length - 1) {
						formattedDescription += "/";
					}
				}
			}

			return formattedDescription;
		} else {
			return description;
		}
	};

	const description = useMemo(
		() => formatDescription(props.description),
		[props.description],
	);

	return (
		<Grid2
			container
			sx={{
				width: "100%",
				backgroundColor: (theme) => theme.palette.background.paper,
				"& .MuiInputBase-input": {
					color: "black",
					cursor: "pointer",
					paddingRight: 45,
				},
			}}
		>
			{!showAssetTree ? (
				<Grid2
					container
					size={{ md: 12, xs: 12 }}
					style={{ position: "relative" }}
					title={props.description}
				>
					<Grid2 style={{ position: "relative", width: "100%" }}>
						<TextField
							id="treePickerTextField"
							label={inputTitle}
							variant="outlined"
							value={description}
							margin="dense"
							autoComplete="off"
							fullWidth
							disabled
							InputProps={{
								endAdornment: (
									<InputAdornment
										position="end"
										style={{
											cursor: "pointer",
										}}
									>
										{showClearButton && value ? (
											<IconButton
												aria-label="clear input"
												onClick={(e) => {
													console.log("onClear -> onSelect");
													e.stopPropagation();
													onSelect(0, "", "");
												}}
												style={{
													cursor: "pointer",
													zIndex: 100,
												}}
												edge="end"
											>
												<ClearIcon />
											</IconButton>
										) : null}
										<AccountTreeIcon
											style={{
												cursor: "pointer",
											}}
										/>
									</InputAdornment>
								),
							}}
						/>
					</Grid2>
					<div
						style={{
							position: "absolute",
							top: 0,
							bottom: 0,
							left: 0,
							right: 0,
							zIndex: 999,
							cursor: "pointer",
						}}
						onClick={handleClickListItem}
					></div>
				</Grid2>
			) : (
				<div></div>
			)}
			<Grid2 size={{ xs: 12, md: 12 }}>
				<ModalTreeFilterControl
					classes={{
						paper: {
							width: "100%",
							maxHeight: 600,
						},
					}}
					onHide={onHide}
					id="modal-treeview-filters"
					title={props.title}
					keepMounted
					open={open}
					onClose={handleClose}
					isLoading={isLoading}
					value={value}
					data={dataSource}
					onBackdropClick={() => setOpen(false)}
					multipleSelectNodes={multipleSelectNodes}
					listAssetDrawings={listAssetDrawings}
					setListAssetDrawings={listAssetDrawings}
					onSuccess={onSuccess}
					allowSearch={allowSearch}
					{...(other as any)}
				></ModalTreeFilterControl>
			</Grid2>
		</Grid2>
	);
};
